<template>
    <div>
        <sweet-modal blocking ref="vendorInvoiceProjectTaskOrder" class="modal" v-on:close="closePurchaseProjectTaskOrder">
            <div style="display:flex; justify-content: center;">
                <h2 @click="click">Vendor Invoice Info</h2>
            </div>

            <el-table
                    :data="[form]"
                    style="width: 100%">
                <el-table-column
                        v-if="action === 'editProject' || action === 'editTask'"
                        :label="labelName">
                    <template slot-scope="scope">
                        {{scope.row.project.name}}
                    </template>
                </el-table-column>
                <el-table-column
                        v-if="action === 'editTask'"
                        label="Task">
                    <template slot-scope="scope">
                        {{scope.row.task.name}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Vendor">
                    <template slot-scope="scope">
                        {{scope.row.vendor.name}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Date">
                    <template slot-scope="scope">
                        <div v-if="scope.row.date">
                            {{moment(scope.row.date.toString(), 'X').format('D MMM YY')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        label="Due Date">
                    <template slot-scope="scope">
                        <div v-if="scope.row.date">
                            {{moment(scope.row.dueDate.toString(), 'X').format('D MMM YY')}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        label="Current Credit">
                    <template slot-scope="scope">
                        {{formatPrice(scope.row.vendorCredit)}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Tax Group">
                    <template slot-scope="scope">
                        {{scope.row.taxGroup}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Reference">
                    <template slot-scope="scope">
                        {{scope.row.reference}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Vendors Ref.">
                    <template slot-scope="scope">
                        {{scope.row.vendorRefs}}
                    </template>
                </el-table-column>
            </el-table>

            <el-row :span="24" style="margin: 20px 0;">
                <div>
                    Description : <br>
                    {{form.description}}
                </div>
                <div style="margin-top:20px;">
                    Terms :<br>
                    {{form.terms}}
                </div>
            </el-row>

            <!--TABLE START -->
            Items
            <el-table
                    size="mini"
                    border
                    :data="form.items"
                    style="width: 100%"
                    :cell-class-name="cellClassName"
                    @cell-click="cellClick">
                <el-table-column
                        label="P.O."
                        width="100">
                    <template slot-scope="scope">
                        {{scope.row.purchaseOrderCode}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Name"
                        width="100">
                    <template slot-scope="scope">
                        {{scope.row.name}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Received On">
                    <template slot-scope="scope">
                        {{moment(scope.row.date.toString(), 'X').format('lll')}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Qty Received"
                        width="130">
                    <template slot-scope="scope">
                        {{scope.row.qtyReceived}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Qty Invoiced"
                        width="130">
                    <template slot-scope="scope">
                        {{scope.row.qtyInvoiced}}
                    </template>
                </el-table-column>
                <!--<el-table-column-->
                    <!--label="Qty Yet To Invoice">-->
                <!--<template slot-scope="scope">-->
                    <!--{{scope.row.yetToInvoice}}-->
                <!--</template>-->
               <!--</el-table-column>-->
                <el-table-column
                        label="Price before Tax">
                    <template slot-scope="scope">
                        {{formatPrice(scope.row.amount)}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Total"
                        width="100">
                    <template slot-scope="scope">
                        {{formatPrice(scope.row.countTotals)}}
                    </template>
                </el-table-column>
            </el-table>
            <!--TABLE END -->
            <el-row :span="24" style="display:flex; justify-content: flex-end">
                <el-col :span="12">
                    <div class="bill">
                        <h4><span>Total Amount : </span>{{formatPrice(form.totalAmount)}}</h4>
                        <el-divider></el-divider>
                    </div>
                </el-col>
            </el-row>
        </sweet-modal>

        <!--PURCHASE ORDER INFO MODAL-->
        <purchaseOrderInfoModal ref="purchaseOrderInfoModal"/>
        <!--PURCHASE ORDER INFO MODAL-->

    </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import purchaseOrderInfoModal from '@/components/purchases/purchaseOrderInfoModal.vue'

  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';


  export default {
    name: "vendorInvoiceInfoModal",
    components:{
      SweetModal,

      purchaseOrderInfoModal
    },
    data() {
      return{
        moment:moment,
        action: 'editProject',
        labelName: 'Project',
        state: 'project',
        activePurchaseId: '',
        form:{
          project: {},
          task: {},
          vendor: {},
          date: null,
          dueDate: null,
          vendorCredit: '0',
          taxGroup: '',
          reference: null,
          vendorRefs: null,
          description: null,
          terms: null,
          items:[],
          //bill
          totalAmount:'0',
        }
      }
    },
    methods:{
      click(){
        console.log(this.form)
      },
      // open modal vendorInvoices
      async openModalInfo(companyId, projectId, projectTaskId, vendorInvoiceId, state, manager){
        this.activePurchaseId = vendorInvoiceId
        console.log('companyId, vendorInvoiceId, state, manager', companyId, 'projectId', projectId, 'projectTaskId', projectTaskId, vendorInvoiceId, state, manager)
        try {
          const urlParts = this.buildUrl(state)
          this.labelName = urlParts.labelName
          this.state = state


          //Get task list
          if(!projectTaskId){
            this.action = 'editProject'
            //Get vendorInvoice item if project
            await this.getVendorInvoiceItem(state, vendorInvoiceId)
          }else if(projectId && projectTaskId) {
            this.action = 'editTask'
            //Get vendorInvoice item if task
            await this.getVendorInvoiceItem(state, vendorInvoiceId)
          }

          this.$refs.vendorInvoiceProjectTaskOrder.open()

        }catch (err){
          console.log(err)
        }
      },
      getVendorInvoiceItem(type, vendorInvoiceId){
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/vendorInvoice/item?type=${type}&id=${vendorInvoiceId}`)
            .then(response => {
                this.form.vendor = response.data.item.vendorInvoice.vendor,
                this.form.date = response.data.item.vendorInvoice.date,
                this.form.dueDate = response.data.item.vendorInvoice.dueDate,
                this.form.taxGroup = response.data.item.vendorInvoice.taxGroup,
                this.form.reference = response.data.item.vendorInvoice.reference,
                this.form.vendorRefs = response.data.item.vendorInvoice.vendorRefs,
                this.form.vendorCredit = response.data.item.vendorInvoice.vendorCredit,
                this.form.description = response.data.item.vendorInvoice.description,
                this.form.terms = response.data.item.vendorInvoice.terms,

                //bill
                this.form.totalAmount = response.data.item.vendorInvoice.totalAmount

              switch(type){
                case 'project':
                  this.form.project = response.data.item.project
                  this.form.task = response.data.item.projectTask
                  break;
                case 'engagement':
                  this.form.project = response.data.item.engagament
                  this.form.task = response.data.item.engagamentTask
                  break;
                case 'businessUnit':
                  this.form.project = response.data.item.businessUnit
                  this.form.task = response.data.item.businessUnitTask
                  break;
              }

              // create item list
              const items = []
              response.data.item.vendorInvoice.items.forEach(val => {
                const item = {
                  code: val.code,
                  name: val.name,
                  amount: val.amount,
                  qty: val.qty,
                  date: val.date * 1000,
                  total: val.total,
                }
                items.push(item)
              })

              this.form.items = response.data.item.vendorInvoice.items

              resolve(response.data.item)
            }).catch(error =>{
            console.log(error)
            reject(error)
          })
        })
      },
      closePurchaseProjectTaskOrder(){
        this.form.vendor = {}
        this.form.date = null
        this.form.dueDate = null
        this.form.taxGroup = null
        this.form.vendorRefs = null
        this.form.vendorCredit = null
        this.form.description = null
        this.form.terms = null
        this.form.totalAmount = null
        this.form.items = []
        this.form.project = {}
        this.form.task = {}
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      cellClassName({row, column, rowIndex, columnIndex}){
        // console.log("COLUMN", columnIndex)
        if(columnIndex === 0){
          return 'p-o'
        }
      },
      cellClick(row, column, cell, event){
        console.log('row', row)
        console.log('column', column)
        console.log('event', event)
        if(column.label === 'P.O.'){
          this.$refs.purchaseOrderInfoModal.openModalInfo(row.companyId, row.projectId || row.engagementId || row.businessUnitId, row.projectTaskId || row.engagementTaskId || row.businessUnitTaskId,  row.purchaseOrderId, this.state, 'user');
        }
      },
      buildUrl(state) {
        let routeName = ''
        let labelName = ''
        let stateProjectId = ''
        let projectId = ''
        let stateTaskId = ''
        let taskId = ''
        let stateExpenseId = ''
        let stateProjectTasks = ''
        let stateTask = ''
        switch (state){
          case 'project':
            routeName = 'projects'
            labelName = 'Project'
            stateProjectId = 'projectId'
            stateProjectTasks = 'projectTasks'
            stateTaskId = 'projectTaskId'
            stateExpenseId = 'projectTaskPurchaseId'
            stateTask = 'projectTask'
            break;
          case 'engagement':
            routeName = 'engagements'
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTasks = 'engagementTasks'
            stateExpenseId = 'engagementTaskPurchaseId'
            labelName = 'Engagement'
            stateTask = 'engagementTask'
            break;
          case 'businessUnit':
            routeName = 'businessUnits'
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateProjectTasks = 'businessUnitTasks'
            stateExpenseId = 'businessUnitTaskPurchaseId'
            labelName = 'Business Unit'
            stateTask = 'businessUnitTask'
            break;
        }
        return {
          state: state,
          routeName: routeName,
          stateProjectId: stateProjectId,
          labelName: labelName,
          projectId: projectId,
          stateTaskId: stateTaskId,
          stateProjectTasks: stateProjectTasks,
          taskId: taskId,
          stateExpenseId: stateExpenseId,
          stateTask: stateTask }
      }
    }
  }
</script>

<style lang="less" scoped>
    /deep/.el-date-editor.el-input, .el-date-editor.el-input__inner {
        width:100%;
    }
    /deep/.sweet-modal-overlay{
        z-index:1000;
        .sweet-modal {
            max-width: 100% !important;
        }
    }
    /deep/.p-o{
        &:hover{
            cursor:pointer;
        }
    }
    .bill{
        text-align:right;
        h4{
            line-height:0.6;
            span{
                padding: 0 10px;
            }
        }
        .payment-to-vendor{
            background: rgb(227, 228, 230);
            h3{
                span{
                    padding: 0 10px;
                }
            }
        }
    }
</style>
